import React from 'react';
import { Accordion, AccordionItem } from '../../../ui';

export const Accordions = () => (
	<>
		<h2 id="accordion">Accordion</h2>
		<Accordion>
			<AccordionItem title="Title of the accordion item 1">
				Body tekst, Lorem ipsum dolor sit amet, consectetur adipisicing elit,
				sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
				enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
				aliquip ex ea commodo consequat.
			</AccordionItem>
			<AccordionItem title="Title of the accordion item 2">
				Some content
			</AccordionItem>
			<AccordionItem title="Title of the accordion item 3">
				Some content
			</AccordionItem>
		</Accordion>
	</>
);
